import { Spinner } from "@blueprintjs/core";
import { useSelectorWall } from "@package/ui-redux";
import { useEffect, useState } from "react";

const CACHING_INDICATOR_TIMEOUT_MS = 1000 * 60;

export function CachingIndicator() {
  const caching = useSelectorWall((state) => state.wall.caching);
  const [showing, setShowing] = useState<boolean>(caching);

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout> | undefined = undefined;

    if (caching) {
      timeout = setTimeout(() => {
        setShowing(false);
      }, CACHING_INDICATOR_TIMEOUT_MS);
    }

    setShowing(caching);

    return () => {
      if (timeout) {
        clearTimeout(timeout);
        timeout = undefined;
      }
    };
  }, [caching]);

  if (showing) {
    return (
      <div className="absolute bottom-8 right-8 z-50">
        <Spinner size={200} />
      </div>
    );
  }

  return null;
}
